import React from 'react';
import Icon from '../../../components/AppIcon';
import MenuItem from './MenuItem';

const CategorySection = ({ category, items, onAddToCart }) => {
  const categoryIcons = {
    tacos: 'Utensils',
    burritos: 'Sandwich',
    quesadillas: 'Pizza',
    nachos: 'Cookie',
    drinks: 'Coffee',
    desserts: 'IceCream'
  };

  if (items?.length === 0) return null;

  return (
    <section className="mb-12">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-full bg-[var(--color-primary)]/20 flex items-center justify-center">
          <Icon name={categoryIcons?.[category] || 'Utensils'} size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-[var(--color-foreground)] capitalize">{category}</h2>
          <p className="text-sm text-[var(--color-muted-foreground)]">{items?.length} items available</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items?.map((item) => (
          <MenuItem key={item?.id} item={item} onAddToCart={onAddToCart} />
        ))}
      </div>
    </section>
  );
};

export default CategorySection;